/**
 * @generated SignedSource<<36d855fd24249dfaf93f59074ef2b8cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanupResult_cleanInfo$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupScanInfo_scanInfo">;
  readonly " $fragmentType": "DiskCleanupResult_cleanInfo";
};
export type DiskCleanupResult_cleanInfo$key = {
  readonly " $data"?: DiskCleanupResult_cleanInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupResult_cleanInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiskCleanupResult_cleanInfo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiskCleanupScanInfo_scanInfo"
    }
  ],
  "type": "CleanInfo",
  "abstractKey": null
};

(node as any).hash = "efa86aaa0db2fe91c0beb5c75cbee466";

export default node;
